export const formatDownloads = (num: number): string => {
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}万`;
  }
  return `${num}`;
};

export const formatDate = (date: string): string => {
  const [y, m, d] = date.split('-');
  return `${y}年${Number(m)}月${Number(d)}日`;
};

export const formatShortDate = (date: string): string => {
  const [y, m, d] = date.split('-');
  return `${y}-${m}-${d}`;
};